<template>
  <div class="sticker-dailog dialog">
    <div class="title">
      <h1>選擇貼紙</h1>
    </div>
    <div class="content container">
      <div class="row" v-show="false">
        <div class="col-12">
          <div class="input-group col-xs-auto">
            <span>請輸入KIT列印單起始位置</span>
          </div>
          <div class="input-group col">
            <input type="text" name="stickerPosition" v-model="position" v-validate="'required'">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <table border="1" class="sticker-table">
            <tr v-for="(_, cindex) in (new Array(10)).fill('')" :key="cindex">
              <td v-for="(_, rindex) in (new Array(3)).fill('')" :class="{ active: position === cindex * 3 + rindex + 1 }" :key="rindex" @click="e => position = cindex * 3 + rindex + 1">
                <span>{{ cindex * 3 + rindex + 1 }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="buttons container">
      <button class="main-button field-button" :class="{ 'loading': onSubmit }" :disabled="disabled" @click="validateExportOrder()">
        <span>確認匯出</span>
      </button>
    </div>
  </div>
</template>

<script>
import { getOrderExport } from '../../api'
import toastMethods from '../../mixins/toastMethods'
import { downloadFile } from '../../constants/global/util.js'

export default {
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({ orders: [] })
    }
  },
  data () {
    return {
      position: '',
      onSubmit: false
    }
  },
  computed: {
    disabled () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.onSubmit) {
        value = true
      }
      return value
    }
  },
  methods: {
    async validateExportOrder () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        await this.exportOrder()
      } else {
        this.addToast('error', '請選擇KIT列印單起始位置')
        this.onSubmit = false
      }
    },
    async exportOrder () {
      try {
        let config = this.$ls.get('userInfo') || {}
        let data = {
          order_ids: this.param.orders.map(order => order.id),
          kit_sticker_start_position: this.position - 0
        }
        let response = await getOrderExport(data, config)
        let result = response.data.data
        for (let url of result.signed_urls) {
          downloadFile(null, url, '_blank')
        }
        this.onSubmit = false
        this.$emit('changeModal', {}, 'exported')
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.onSubmit = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/sticker.vue